import { render, staticRenderFns } from "./AdminQuickReturn.vue?vue&type=template&id=c001d9ac&scoped=true&"
import script from "./AdminQuickReturn.vue?vue&type=script&lang=js&"
export * from "./AdminQuickReturn.vue?vue&type=script&lang=js&"
import style0 from "./AdminQuickReturn.vue?vue&type=style&index=0&id=c001d9ac&lang=scss&scoped=true&"
import style1 from "./AdminQuickReturn.vue?vue&type=style&index=1&id=c001d9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c001d9ac",
  null
  
)

export default component.exports